import { Component, ChangeDetectionStrategy } from '@angular/core';

import { SearchBarMobileService } from '@search-bar/services/search-bar-mobile.service';
import {
  PackagesDestinationAbstractComponent
} from '@packages/packages-search-bar/abstract/packages-destination.component.abstract';

import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-packages-destination-mobile',
  templateUrl: './packages-destination-mobile.component.html',
  styleUrls: ['./packages-destination-mobile.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PackagesDestinationMobileComponent extends PackagesDestinationAbstractComponent {

  public readonly iconLocation = Icon.Location;
  public readonly iconStarPoint= Icon.StartPoint;

  constructor(
    protected searchBarMobileService: SearchBarMobileService
  ) {
    super(searchBarMobileService);
  }

}
